import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { t } from 'i18next';
import { PiSignIn } from 'react-icons/pi';
import { IProviderBlobConnectionResponse } from 'services/providers/types';

const BlobKyesTab = () => {
  const {
    values,
    status,
  }: IFormikContextType<IProviderBlobConnectionResponse> =
    useFormikContext<IProviderBlobConnectionResponse>();

  return (
    <div className='flex flex-col self-start w-full max-w-[370px] gap-4'>
      <Container>
        <Container.Header
          title={
            <>
              <PiSignIn /> {t('provider.ftp.passes')}
            </>
          }
        />
        <Container.Content>
          <FormInput.Text
            name='accountKey'
            label={t('input.label.accountKey')}
          />
        </Container.Content>
      </Container>
    </div>
  );
};

export default BlobKyesTab;
